module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/OIS Anti-shake Camera Module.0b85c099.png";